import React, { useEffect, useState } from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import Icon from '@mdi/react';
import { mdiFolderStar } from '@mdi/js';
import PropTypes from 'prop-types';
import { ContentState, EditorState, convertFromHTML } from 'draft-js';
import { withTranslation } from 'react-i18next';
import GraphQL from '../../../GraphQL';
import Modal from '../Modal';
import { memoTemplateListOnlyActiveByApplicationType } from '../../queries/MemoTemplates';
import { TEMPLATE_APPLICATION_TYPE } from '../../utils/constants';

const SelectSmartHtmlEditor = (props) => {
  const { t, editorState, onChange, onTemplateChange } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [content, setContent] = useState({});

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const onContentChange = ({ defaultTitle, defaultBodyInHTML }) => {
    if (modal) {
      toggleModal();
    }
    const contentState = ContentState.createFromBlockArray(
      convertFromHTML(`${defaultTitle || ''}\n\n${defaultBodyInHTML || ''}`)
    );
    if (onTemplateChange) {
      onTemplateChange({ body: defaultBodyInHTML, title: defaultTitle });
    }
    onChange(EditorState.createWithContent(contentState));
  };

  const onSelectChange = async (item) => {
    setContent(item);
    handleClose();
    const currentContent = await editorState.getCurrentContent().getPlainText();
    if (currentContent.length > 0) {
      toggleModal();
    } else {
      onContentChange(item);
    }
  };

  const loadAllTemplate = () => {
    const dataQuery = memoTemplateListOnlyActiveByApplicationType(
      TEMPLATE_APPLICATION_TYPE.COMU
    );
    GraphQL(dataQuery, {})
      .then((res) => {
        if (res.memoTemplateListByFilter) {
          setData(res.memoTemplateListByFilter);
        }
      })
      .catch();
  };

  useEffect(() => {
    loadAllTemplate();
  }, []);

  return (
    <div className="select-smart-html-editor rdw-colorpicker-wrapper">
      {modal && (
        <Modal
          color="warning"
          title={t('notifications.attention')}
          btn="Warning"
          message={t('notifications.replace_content')}
          toggle={toggleModal}
          modal={modal}
          onConfirm={() => onContentChange(content)}
        />
      )}
      <button
        type="button"
        className="rdw-option-wrapper icon-button"
        title={t('general.select-template')}
        onClick={handleClick}
      >
        <Icon path={mdiFolderStar} size={1} />
      </button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {data.length &&
          data.map((item) => (
            <MenuItem key={item.id} onClick={() => onSelectChange(item)}>
              {item.name}
            </MenuItem>
          ))}
      </Menu>
    </div>
  );
};

SelectSmartHtmlEditor.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  editorState: PropTypes.shape(PropTypes.shape).isRequired,
  onTemplateChange: PropTypes.func,
};

SelectSmartHtmlEditor.defaultProps = {
  onTemplateChange: null,
};

export default withTranslation('common')(SelectSmartHtmlEditor);
